module.exports = __webpack_public_path__ + "static/media/graphic-dashboard-create-user@2x.aa83ad15.png";